import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import crossIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg'
import calendarIcon from '../../../../../_metronic/assets/images/svg/data-room/calendar-solid-icon.svg'
import { Formik, ErrorMessage, Form } from 'formik'
import * as Yup from 'yup'
import { useAuth } from '../../../auth'
import { CustomButton } from '../../../widgets/components/UI/CustomButton'
import TextInput from '../../../widgets/components/Input/TextInput'
import { createActivityLog, createShareDocument } from '../../core/_requests'
import { toast } from 'react-toastify'
import CreateLinkModal from './CreateLinkModal'
import { getLocation } from '../../../onboarding/core/_requests'
import { ToolTipUIForModal } from '../../../widgets/components/UI/ToolTipUIForModal'

export const RecordKeeperCreateLinkDrawer = ({
  recordId,
  createLinkDrawer,
  setCreateLinkDrawer,
  setCreateRecordDrawer
}: {
  recordId: string | undefined
  createLinkDrawer: boolean
  setCreateLinkDrawer: (value: boolean) => void
  setCreateRecordDrawer?: any
}) => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const [loading, setLoading] = useState(false)
  const [passcodeEnabled, setPasscodeEnabled] = useState(false)
  const [dateEnabled, setDateEnabled] = useState(false)
  const [allowDownload, setAllowDownload] = useState(false)
  const [requireEmail, setRequireEmail] = useState(false)
  const [, setImgName] = useState<string | undefined>()
  const [accessControlEnabled, setAccessControlEnabled] = useState(false)
  const [currentDate, setCurrentDate] = useState('')
  const [isCreateLinkActive, setIsCreateLinkActive] = useState(false)
  const [url, setUrl] = useState('')
  useEffect(() => {
    const today = new Date()
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(today.getDate()).padStart(2, '0')}`
    setCurrentDate(formattedDate)
  }, [])

  const createShareLinkSchema = (isPasscodeEnabled: boolean) => {
    return Yup.object().shape({
      passcode: isPasscodeEnabled
        ? Yup.string()
          .required(formatMessage({ id: '*Passcode is required' }))
          .min(6)
        : Yup.string().min(6),
    })
  }

  const initialValues = {
    passcodeEnabled: false,
    passcode: '',
    expiryonlyDate: '',
    expiryTime: '',
    allowDownload: false,
    requireEmail: false,
    dateEnabled: false,
  }

  const handleDrawerClose = (formik: any) => {
    formik.resetForm()
    setPasscodeEnabled(false)
    setDateEnabled(false)
    setAllowDownload(false)
    setRequireEmail(false)
    setImgName('')
    setAccessControlEnabled(false)
    setCreateLinkDrawer(false)
  }

  const updateExpiryDate = (expiryonlyDate: any, expiryTime: any, setFieldValue: any) => {
    if (expiryonlyDate && expiryTime) {
      const combinedDateTime = new Date(`${expiryonlyDate} ${expiryTime}`).toISOString()
      setFieldValue('expiryDate', combinedDateTime)
    } else {
      setFieldValue('expiryDate', '')
    }
  }
  const getDeviceType = () => {
    const ua = navigator.userAgent

    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera Mobi|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
        ua
      )
    ) {
      return 'MOBILE'
    }
    return 'WEB'
  }

  const getOS = () => {
    const ua = navigator.userAgent
    if (/iPhone|iPad|iPod|Macintosh/.test(ua)) return 'APPLE'
    if (/Win/.test(ua)) return 'WINDOWS'
    if (/android/i.test(ua)) return 'ANDROID'
    return 'Unknown'
  }
  const createActivity = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name
    const ipAddress = locationApiData?.data?.ip
    try {
      if (deviceTypeView && os && city && recordId && companyId) {
        const {
          data: { success, errors },
        } = await createActivityLog(
          companyId,
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'SHARED'
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  const handleSubmit = async (values: any, { resetForm }: any) => {
    setLoading(true)
    try {
      const payload = {
        passCode: values.passcode,
        isExpires: dateEnabled,
        expireDateNTime: `${values.expiryonlyDate}${values.expiryTime}`,
        isDownload: values.allowDownload,
        isEmailView: values.requireEmail,
        isPassCode: passcodeEnabled,
      }
      if (companyId && recordId) {
        const {
          data: { success, errors, data },
        } = await createShareDocument(companyId, recordId, payload)
        if (success) {
          createActivity(recordId)
          setLoading(false)
          resetForm()
          setPasscodeEnabled(false)
          setDateEnabled(false)
          setAllowDownload(false)
          setRequireEmail(false)
          setImgName('')
          setUrl(data)
          setIsCreateLinkActive(true)
          setAccessControlEnabled(false)
          toast.success(formatMessage({ id: 'Share Link Created successfully' }))
        } else {
          setImgName('')
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }
  //drawer-end
  const onClose = () => {
    setCreateLinkDrawer(false)
    setIsCreateLinkActive(false)
    if (setCreateRecordDrawer)
      setCreateRecordDrawer(true)
  }
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={createShareLinkSchema(passcodeEnabled)}
        onSubmit={(values, formikHelpers) => handleSubmit(values, formikHelpers)}
      >
        {(formik) => {
          return (
            
              <div
                id='kt_create_link'
                className={
                  createLinkDrawer
                    ? 'bg-body drawer drawer-end drawer-on'
                    : 'bg-body drawer drawer-end'
                }
                data-kt-drawer='true'
                data-kt-drawer-name='activities'
                data-kt-drawer-activate='true'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width="{default:'320px', 'md': '660px' ,'lg': '847px'}"
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_create_link_toggle'
                data-kt-drawer-close='#kt_create_link_close'
                style={{ width: '847px' }}
              >
                <div className='create_link-drawer d-flex flex-row'>
                  <div className=' create_link-drawer-wrapper card shadow-none rounded-0'>
                    <div
                      className='drawer-header d-flex flex-row align-items-center justify-content-between flex-wrap  '
                      id='kt_create_link_header'
                    >
                      <div className='d-flex flex-row align-items-center   w-100'>
                        <button
                          type='button'
                          className='btn p-0 btn-active-light-primary me-4 '
                          onClick={() => handleDrawerClose(formik)}
                        >
                          <img src={crossIcon} alt=''></img>
                        </button>

                        <div className='d-flex flex-row align-items-center  justify-content-between flex-grow-1 '>
                          <h3 className='drawer-head-title  mb-0 me-4 text-dark'>
                            {formatMessage({ id: 'Share Document' })}
                          </h3>

                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'GLOBAL.TOOLTIP.DATAROOM.FILES.CREATE_LINK_DRAWER',
                            })}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className='create_link-drawer-body px-5 pt-4  pt-md-7 px-md-7 pb-md-0 '
                      id='kt_create_link_body'
                    >
                      <div
                        id='kt_create_link_scroll'
                        className='w-100 d-flex flex-column align-items-center mb-5 mt-2 activity-container-n overflow-visible'
                      >
                        <Form onSubmit={formik.handleSubmit} className='w-100'>
                          <div className='mb-6'>
                            <div className='mb-3 form-check d-flex flex-row align-items-center'>
                              <input
                                type='checkbox'
                                name='passcode'
                                className='form-check-input'
                                aria-describedby='passcodeTextHelp'
                                id='Passcode'
                                checked={passcodeEnabled}
                                onChange={() => {
                                  setPasscodeEnabled(!passcodeEnabled)
                                  formik.setFieldValue('passcode', '')
                                }}
                              />
                              <label className='form-check-label mx-3 ' htmlFor='Passcode'>
                                {formatMessage({ id: 'Passcode' })}
                              </label>

                              <ToolTipUIForModal
                                tooltipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.DATAROOM.CREATE_LINK_DRAWER.PASSWORD',
                                })}
                              />
                            </div>
                            <input
                              type='text'
                              name='passcode'
                              placeholder={formatMessage({ id: 'Passcode (min. 6 characters)' })}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.passcode}
                              className='form-control'
                              id='exampleInputPassword1'
                              disabled={!passcodeEnabled}
                            />
                            <ErrorMessage
                              name='passcode'
                              component='div'
                              className='error-message text-danger'
                            />
                            <div id='passcodeTextHelp' className='form-text'>
                              {formatMessage({
                                id: 'Viewers must enter above passcode(min. 6 characters) to open your dataroom.',
                              })}
                            </div>
                          </div>
                          <div className='mb-6'>
                            <div className='mb-3 form-check d-flex flex-row align-items-center'>
                              <input
                                type='checkbox'
                                className='form-check-input'
                                id='Expires'
                                onChange={() => {
                                  setDateEnabled(!dateEnabled)
                                  formik.setFieldValue('expiryonlyDate', '')
                                  formik.setFieldValue('expiryTime', '')
                                }}
                                checked={dateEnabled}
                              />
                              <label className='form-check-label mx-3' htmlFor='Expires'>
                                {formatMessage({ id: 'Expires' })}
                              </label>

                              <ToolTipUIForModal
                                tooltipText={formatMessage({
                                  id: 'GLOBAL.TOOLTIP.DATAROOM.CREATE_LINK_DRAWER.EXPIRY_DATE',
                                })}
                              />
                            </div>

                            <div className='d-flex flex-column flex-md-row align-items-center Expires-input-grid'>
                              <div className='flex-grow-1 w-100 position-relative'>
                                <input
                                  type='date'
                                  className='form-control flex-grow-1'
                                  name='expiryonlyDate'
                                  id='Expires-date'
                                  placeholder={formatMessage({ id: 'Select date' })}
                                  onChange={(event) => {
                                    formik.handleChange(event)
                                    const expiryonlyDate = event.target.value
                                    const expiryTime = formik.values.expiryTime
                                    updateExpiryDate(
                                      expiryonlyDate,
                                      expiryTime,
                                      formik.setFieldValue
                                    )
                                  }}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.expiryonlyDate}
                                  disabled={!dateEnabled}
                                  min={currentDate}
                                />
                                <img src={calendarIcon} className='position-absolute' alt='' />
                              </div>
                              <div className='flex-grow-1 w-100 position-relative '>
                                <TextInput
                                  fieldType={'time'}
                                  fieldName={'expiryTime'}
                                  formik={formik}
                                  placeholder=''
                                  isTooltipNotRequired={true}
                                  isWidthNotRequired={true}
                                  isDisabled={!dateEnabled}
                                  isMargin={'mb-0'}
                                  width={100}
                                />
                              </div>
                            </div>

                            <div id='' className='form-text mt-3'>
                              {formatMessage({ id: 'Viewers can download your file.' })}
                            </div>
                          </div>

                          <div className='mb-5 form-check d-flex flex-row '>
                            <input
                              type='checkbox'
                              className='form-check-input'
                              id='AllowDownloading'
                              name='allowDownload'
                              onChange={(event) => {
                                const isChecked = event.target.checked
                                setAllowDownload(isChecked)
                                formik.setFieldValue('allowDownload', isChecked)
                              }}
                              checked={allowDownload}
                            />
                            <label
                              className='form-check-label mx-3 mt-n1'
                              htmlFor='AllowDownloading'
                            >
                              {formatMessage({ id: 'Allow downloading ' })}
                              <br></br>{' '}
                              <span className='viewers-text'>
                                {' '}
                                {formatMessage({ id: 'Viewers can download your file.' })}
                              </span>
                            </label>
                          </div>
                          <div className='mb-5 form-check d-flex flex-row '>
                            <input
                              name='requireEmail'
                              type='checkbox'
                              className='form-check-input'
                              id='RequireEmailToView'
                              onChange={(event) => {
                                const isChecked = event.target.checked
                                setRequireEmail(isChecked)
                                formik.setFieldValue('requireEmail', isChecked)
                              }}
                              checked={requireEmail}
                            />
                            <label
                              className='form-check-label mx-3 mt-n1'
                              htmlFor='RequireEmailToView'
                            >
                              {formatMessage({ id: 'Require email to view' })}
                              <br></br>{' '}
                              <span className='viewers-text'>
                                {formatMessage({
                                  id: 'Viewers must enter an email to view your document. ',
                                })}
                              </span>
                            </label>
                          </div>

                          <div
                            className='create_link-drawer-footer d-flex justify-content-end'
                            id='kt_footer'
                          >
                            <button
                              type='button'
                              onClick={() => handleDrawerClose(formik)}
                              className='btn btn-light flex-grow-1 flex-md-grow-0  '
                            >
                              {formatMessage({ id: 'Cancel' })}
                            </button>
                            <CustomButton
                              isSubmitting={formik.isSubmitting}
                              isValid={formik.isValid}
                              buttonText={formatMessage({ id: 'Share' })}
                              loading={loading}
                              widthLoading={2}
                              width={2}
                              isdisable={accessControlEnabled}
                            />
                          </div>
                        </Form>
                      </div>
                    </div>
                    {/* begin::Footer */}

                    {/* end::Footer */}
                  </div>
                </div>
              </div>
           
          )
        }}
      </Formik>
      <CreateLinkModal
        isActive={isCreateLinkActive}
        setIsActive={setIsCreateLinkActive}
        close={onClose}
        url={url}
      />
    </>
  )
}
